<template>
    <router-view />
</template>

<script>
import { inject, onMounted, onUnmounted } from 'vue'
export default {
  name: 'LandingPageLayout',
  setup: () => {

      const socket = inject("socket")

      onMounted(() => {
          socket.on('notification.123',(data) => {
              console.log('Listened');
              console.log(data);
          });
      });

      onUnmounted(() => {
          socket.off()
      });

      const em = () => {
          socket.emit("notification", {
              message: "test message",
              user: "123"
          });
      }

      return {em}
  }
}
</script>
